"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveThread = resolveThread;
function resolveThread(weave, planId) {
    return weave.threads.find(t => t.plans.some(p => p.id === planId));
}
